export default __webpack_public_path__ + "static/media/element_83.1e9239a2.jpg";